
<div id="appCapsule" style="padding-bottom: 0px;">
    <router-outlet (activate)="onActivate()"></router-outlet>
</div>

